import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LayoutContainerStyled = styled(Box)({
  display: "flex",
  width: "100%",
  height: "100vh",
});

export const MainStyled = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
})<{ open: boolean; isMobile: boolean }>(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(0),
  paddingTop: theme.spacing(14.12),
  transition: theme.transitions.create(["padding-left"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),

  backgroundColor: "white",
  minHeight: "fit-content",
  width: `100%`,
}));
